import React, { useState, useEffect } from 'react';
import { Search, ExternalLink, Music } from 'lucide-react';
import { ReleaseCardSkeleton } from '../components/LoadingSkeleton';
import { api } from '../api';

export default function Releases() {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filteredReleases, setFilteredReleases] = useState([]);

  useEffect(() => {
    api.getReleases()
      .then((data) => {
        setReleases(data.releases || []);
        setFilteredReleases(data.releases || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Failed to load releases:', err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!search.trim()) {
      setFilteredReleases(releases);
    } else {
      const q = search.toLowerCase();
      setFilteredReleases(
        releases.filter((r) =>
          r.title.toLowerCase().includes(q) ||
          r.artist_name.toLowerCase().includes(q)
        )
      );
    }
  }, [search, releases]);

  return (
    <div data-testid="releases-page">
      <div className="page-header">
        <h1>Releases</h1>
        <p>Explore the CloudfiMusic discography</p>
      </div>

      <div className="section" style={{ paddingTop: '1rem' }}>
        <div className="section-inner">
          {/* Search */}
          <div className="search-bar" data-testid="release-search">
            <Search size={18} className="search-icon" />
            <input
              type="text"
              placeholder="Search releases or artists..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              data-testid="release-search-input"
            />
          </div>

          {/* Grid */}
          <div className="releases-grid">
            {loading
              ? Array.from({ length: 12 }).map((_, i) => <ReleaseCardSkeleton key={i} />)
              : filteredReleases.map((release, i) => (
                  <div className="release-card" key={release.id || i} data-testid={`release-card-${i}`}>
                    <div className="release-card-image">
                      {release.cover_image ? (
                        <img
                          src={release.cover_image}
                          alt={release.title}
                          loading="lazy"
                        />
                      ) : (
                        <div style={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          background: 'var(--bg-surface)',
                        }}>
                          <Music size={32} color="var(--text-muted)" />
                        </div>
                      )}
                    </div>
                    <div className="release-card-body">
                      <div className="release-card-title">{release.title}</div>
                      <div className="release-card-artist">{release.artist_name}</div>
                      {release.spotify_url && (
                        <a
                          href={release.spotify_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="release-card-link"
                        >
                          <ExternalLink size={12} /> Listen on Spotify
                        </a>
                      )}
                    </div>
                  </div>
                ))}
          </div>

          {!loading && filteredReleases.length === 0 && (
            <div className="empty-state">
              <Music size={48} />
              <h3>No releases found</h3>
              <p>Try a different search term</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
